var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2039 3.17642C14.0714 2.0439 12.2352 2.0439 11.1027 3.17642L4.56193 9.71716C2.74599 11.5331 2.74599 14.4773 4.56193 16.2932C6.37787 18.1092 9.32208 18.1092 11.138 16.2932L17.3252 10.1061C17.5595 9.87175 17.9394 9.87175 18.1737 10.1061C18.408 10.3404 18.408 10.7203 18.1737 10.9546L11.9866 17.1418C9.70198 19.4263 5.99797 19.4263 3.7134 17.1418C1.42884 14.8572 1.42884 11.1532 3.7134 8.86863L10.2541 2.32789C11.8553 0.726742 14.4513 0.726742 16.0524 2.32789C17.6536 3.92904 17.6536 6.52502 16.0524 8.12617L9.86523 14.3134C8.9475 15.2311 7.45956 15.2311 6.54183 14.3134C5.6241 13.3956 5.6241 11.9077 6.54183 10.9899L12.3755 5.15632C12.6098 4.922 12.9897 4.922 13.224 5.15632C13.4583 5.39063 13.4583 5.77053 13.224 6.00485L7.39036 11.8385C6.94125 12.2876 6.94125 13.0157 7.39036 13.4648C7.83946 13.9139 8.5676 13.9139 9.0167 13.4648L15.2039 7.27764C16.3364 6.14512 16.3364 4.30894 15.2039 3.17642Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.b93e98af1d11ec2e0e09b80dd100d130.svg";
export { ForwardRef as ReactComponent };